// src/pages/NotificationScreen.jsx
import { Card, List, Typography, message, Button, Spin } from "antd";
import { LeftOutlined, DeleteOutlined } from "@ant-design/icons";
import { motion, AnimatePresence } from "framer-motion";
import { markNotificationRead, clearAllNotifications } from "../../api/NotificationApi";

const { Text, Title } = Typography;

const NotificationScreen = ({ onBack, notifications, setNotifications, loading }) => {

  const handleMarkRead = async (id) => {
    try {
      await markNotificationRead(id);
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    } catch (err) {
      message.error("Failed to mark as read");
    }
  };

  const handleClearAll = async () => {
    try {
      await clearAllNotifications();
      setNotifications([]);
      message.success("All notifications cleared");
    } catch (err) {
      message.error("Failed to clear notifications");
    }
  };

  return (
    <div>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 16,
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <LeftOutlined
            style={{ marginLeft: 8, fontSize: 14, color: "#1890ff", cursor: "pointer" }}
            onClick={onBack}
          />
          &nbsp;
          <Title level={4} style={{ margin: 0 }}>
            Notifications
          </Title>
        </div>

        {notifications?.length > 0 && (
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={handleClearAll}
            danger
          >
            Clear All
          </Button>
        )}
      </div>

      {/* Notification List */}
      {loading ? (
        <Spin size="large" />
      ) : (
        <List
          dataSource={notifications}
          renderItem={(item) => (
            <AnimatePresence key={item.id}>
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.3 }}
                onClick={() => handleMarkRead(item.id)}
              >
                <Card
                  hoverable
                  style={{ marginBottom: 12, borderRadius: 12, cursor: "pointer" }}
                >
                  <Title level={5}>{item.title}</Title>
                  <Text>{item.message}</Text>
                  <br />
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {new Date(item.createdAt).toLocaleString()}
                  </Text>
                </Card>
              </motion.div>
            </AnimatePresence>
          )}
        />
      )}
    </div>
  );
};

export default NotificationScreen;
